import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';
import { CountryService } from '../../services/countryService';
import { rebrandCarrierProviderNames } from '../../components/data-driven-logo/name-utils';

export const getLabelProviders = (homeCountry) => {
  const request = axios.get('/provider/seller').then((response) => {
    const { data } = response ?? {};
    if (data && homeCountry) {
      return rebrandCarrierProviderNames(data, homeCountry);
    }
    return data;
  });

  const data$ = from(request);
  return data$;
};

export const getSellerCarrierIds = () => {
  const request = axios.get('/carrier/seller/carrierIds').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const getCountries = () => {
  const localStorageCountries = CountryService.getCountriesFromLocalStorage();
  if (localStorageCountries) {
    const promise = new Promise((resolve) => {
      setTimeout(() => {
        resolve(localStorageCountries);
      }, 0);
    });
    return from(promise);
  }
  const request = axios.get('/reference/country').then((response) => {
    const countries = get(response, 'data', undefined);
    CountryService.writeCountriesToLocalStorage(countries);
    return countries;
  });

  const data$ = from(request);
  return data$;
};

export const getAllTheCarriers = () => {
  const request = axios.get('/carrier').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const getStates = () => {
  const localStorageStates = CountryService.getStatesFromLocalStorage();
  if (localStorageStates) {
    const promise = new Promise((resolve) => {
      setTimeout(() => {
        resolve(localStorageStates);
      }, 0);
    });
    return from(promise);
  }
  const request = axios.get('/reference/state').then((response) => {
    const states = get(response, 'data', undefined);
    CountryService.writeStatesToLocalStorage(states);
    return states;
  });

  const data$ = from(request);
  return data$;
};

export const getServiceClassifications = () => {
  const request = axios.get('/service/classifications').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const getShippingOptions = () => {
  const request = axios.get('/IntegrationsShippingPlatform/ShippingOptions').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const getProviderDisplayInfo = (homeCountry) => {
  const request = axios.get('/IntegrationsPlatform/displayInfo/providers').then((response) => {
    const { data } = response ?? {};
    if (data && homeCountry) {
      return rebrandCarrierProviderNames(data, homeCountry);
    }
    return data;
  });

  const data$ = from(request);
  return data$;
};

export const getMarketplaceDisplayInfo = () => {
  const request = axios.get('/IntegrationsPlatform/displayInfo/ordersources').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const getFulfillmentProviderDisplayInfo = () => {
  const request = axios.get('/IntegrationsPlatform/displayInfo/fulfillmentproviders').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const getFulfillmentOptions = () => {
  const fulfillmentOptions = axios.get('IntegrationsPlatform/FulfillmentOptions').then((response) => get(response, 'data', undefined));

  return from(fulfillmentOptions);
};

export const getServiceReference = () => {
  const request = axios.get('/reference/service').then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};
